import React from 'react'
import NavbarGuest from './NavbarGuest'
import Footer from "./Footer";

export default function Thankyou() {
  return (
    <>
      <section className="fullScreenLayout">
        <NavbarGuest />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ padding: "20px", flex: "1" }}
        >
          <div style={{ padding: "3rem 1.5rem", maxWidth: "400px" }}>
            <h2 className="text-center login">Thank you!</h2>
            <p className='text-center para'>We have send a verification link to your email. Please verify your email to complete the registration.</p>
            {/* <p className='review-text'>Once your account is approved, you will receive an email from support@cibermed.com for account activation.</p> */}
            {/* <br/><Link to="/login" className='next-btn mt-5' style={{textDecoration:'none'}}>Go Back to Home</Link> */}
          </div>
        </div>
        <Footer />
      </section>
    </>
  )
}
